import { DEFAULT_MODE, makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const TEXT_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const BUTTONS_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const SPINNER_SIZE = {
  [HD]: 32,
  [FULL_HD]: 32,
};

export const getInitialStyle = ({ screenSize = FULL_HD, colorMode = DEFAULT_MODE } = defaultContext) => {
  const w = SCREEN_WIDTH[screenSize] * 0.7;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    flex: {
      direction: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    Title: {
      text: {
        ...getFont(FONT.PARIS_2, screenSize),
        textAlign: 'center',
        wordWrapWidth: w,
        textColor: colors.text[colorMode],
      },
      flexItem: {
        marginBottom: TEXT_MARGIN[screenSize],
      },
    },
    Description: {
      text: {
        ...getFont(FONT.OTTAWA_1, screenSize),
        textAlign: 'center',
        wordWrapWidth: w,
        textColor: colors.text[colorMode],
      },
    },
    Buttons: {
      w,
      flexItem: {
        marginTop: BUTTONS_MARGIN[screenSize],
      },
      flex: {
        alignItems: 'center',
        justifyContent: 'center',
        direction: 'row',
      },
      Accept: {
        flexItem: {
          marginRight: BUTTONS_MARGIN[screenSize],
        },
      },
      Decline: {},
    },
    Spinner: {
      visible: false,
      w: SPINNER_SIZE[screenSize],
      h: SPINNER_SIZE[screenSize],
      flexItem: {
        marginTop: BUTTONS_MARGIN[screenSize],
      },
    },
  };
};
